"use strict";

var _interopRequireDefault = require("D:/G/YT/mes-project-web/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator2 = _interopRequireDefault(require("D:/G/YT/mes-project-web/node_modules/@babel/runtime/helpers/regenerator.js"));
var _asyncToGenerator2 = _interopRequireDefault(require("D:/G/YT/mes-project-web/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
require("core-js/modules/es.array.filter.js");
require("core-js/modules/es.array.map.js");
require("core-js/modules/es.function.name.js");
require("core-js/modules/es.iterator.constructor.js");
require("core-js/modules/es.iterator.every.js");
require("core-js/modules/es.iterator.filter.js");
require("core-js/modules/es.iterator.map.js");
require("core-js/modules/es.number.constructor.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.regexp.test.js");
var _auth = require("@/utils/auth");
var _default2 = exports.default = {
  name: 'wl-dialog-import',
  /* 混入 */
  // mixins,
  // components: { fileView, fileFullImage },
  props: {
    open: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    width: {
      type: [String, Number],
      default: '500px'
    },
    loading: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    btnOptions: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    dialogOptions: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    uploadOptions: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    'import-url': {
      type: String,
      default: ''
    },
    'download-template-request': {
      type: Function,
      default: function _default() {}
    }
  },
  data: function data() {
    return {
      visible: false,
      upload: {
        // 是否显示弹出层（用户导入）
        open: false,
        // 弹出层标题（用户导入）
        title: '封帐期间导入',
        // 是否禁用上传
        isUploading: false,
        // 是否更新已经存在的数据
        updateSupport: true,
        // 设置上传的请求头部
        headers: {
          Authorization: 'Bearer ' + (0, _auth.getToken)()
        },
        // 文件类型
        accept: '.xlsx, .xls',
        // 列表类型
        'list-type': 'text',
        // 自动上传？
        'auto-upload': false,
        // 是否是列表？
        'is-list': true,
        // 是否启用拖拽？
        drag: true
        // // 上传的地址
        // url          :
        //   process.env.VUE_APP_BASE_API + '/system/account-period/importData'
      }
    };
  },
  computed: {
    getUploadOptions: function getUploadOptions() {
      var options = this.$$deepMerge(this.upload, this.uploadOptions);
      if (this.importUrl) options.action = this.importUrl + '?isUpdateSupport=' + this.upload.updateSupport;
      return options;
    }
  },
  watch: {
    open: {
      handler: function handler(nv) {
        this.visible = nv;
      },
      immediate: true
    },
    visible: {
      handler: function handler(nv) {
        this.$emit('update:open', nv);
      }
    }
  },
  methods: {
    // 文件上传中处理
    handleFileUploadProgress: function handleFileUploadProgress() {
      this.$emit('update:loading', true);
    } /* event, file, fileList */,
    /** 下载模板操作 */downloadTemplate: function downloadTemplate() {
      var _this = this;
      return (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee() {
        var _this$downloadTemplat;
        return (0, _regenerator2.default)().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              if (typeof _this.downloadTemplateRequest === 'function') {
                (_this$downloadTemplat = _this.downloadTemplateRequest(_this)) === null || _this$downloadTemplat === void 0 || (_this$downloadTemplat = _this$downloadTemplat.then(function (res) {
                  if ((res === null || res === void 0 ? void 0 : res.code) === 200) {
                    _this.$message.success('模版获取成功，请等待开始下载！');
                    _this.download(res.data);
                  } else {
                    _this.$message.warning('模版获取失败！');
                  }
                })) === null || _this$downloadTemplat === void 0 || _this$downloadTemplat.catch(function (err) {
                  console.error(err);
                  _this.$message.warning('模版获取失败！');
                });
              }
            case 1:
              return _context.a(2);
          }
        }, _callee);
      }))();
    },
    submitFileForm: function submitFileForm() {
      this.$refs['import-upload'].submit();
    },
    onSuccess: function onSuccess(response, file, files) {
      var filesStatus = files.map(function (item) {
        return item.status;
      });
      var filesAllStatus = filesStatus.every(function (status) {
        return /^(success|error)$/i.test(status);
      });
      this.$emit('update:loading', !filesAllStatus);
      if (filesAllStatus) {
        var _this$$refs$importUp, _ref, _this$$attrs$onSucces;
        var h = this.$createElement;
        var filesUploadSuccess = files.filter(function (item) {
          var _item$response;
          return ((_item$response = item.response) === null || _item$response === void 0 ? void 0 : _item$response.code) === 200;
        });
        // .length

        var filesUploadError = files.filter(function (item) {
          var _item$response2;
          return ((_item$response2 = item.response) === null || _item$response2 === void 0 ? void 0 : _item$response2.code) !== 200;
        });
        // .length

        this.$notify({
          title: '导入完成！',
          // type    : 'success',
          duration: filesUploadError.length ? 0 : 3000,
          // duration: 3000,
          message: h('div', {
            // style: 'color: teal;white-space: pre-wrap;'
          }, [filesUploadSuccess.length ? h('div', [h('div', {
            style: 'color: #67C23A;font-size: 1.1em;'
          }, [h('b', '成功：')]), filesUploadSuccess.map(function (f) {
            return h('div', [h('div', {
              style: 'margin-right: 2em;white-space: pre-wrap;'
            }, [h('b', f.name)])]);
          })]) : null, filesUploadError.length ? h('div', [h('div', {
            style: 'color: #F56C6C;font-size: 1.1em;'
          }, [h('b', '失败：')]), filesUploadError.map(function (f) {
            var _f$response;
            return h('div', [h('div', {
              style: 'margin-right: 2em;white-space: pre-wrap;'
            }, [h('b', f.name)]), h('div', {
              style: 'margin-left : 2em;color: #F56C6C;text-align: right;white-space: pre-wrap;'
            }, (_f$response = f.response) === null || _f$response === void 0 ? void 0 : _f$response.message)]);
          })]) : null]
          // errMsg
          )
        });
        this.visible = false;
        (_this$$refs$importUp = this.$refs['import-upload']) === null || _this$$refs$importUp === void 0 || _this$$refs$importUp.clearFiles();
        ((_ref = (_this$$attrs$onSucces = this.$attrs.onSuccess) !== null && _this$$attrs$onSucces !== void 0 ? _this$$attrs$onSucces : this.$attrs['on-success']) !== null && _ref !== void 0 ? _ref : function () {})(response, file, files);
      }
    }
  },
  mounted: function mounted() {},
  beforeDestroy: function beforeDestroy() {}
};